import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=2843cdcf&scoped=true&"
import script from "./AdminPage.vue?vue&type=script&lang=ts&"
export * from "./AdminPage.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPage.vue?vue&type=style&index=0&id=2843cdcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2843cdcf",
  null
  
)

export default component.exports